<template>
    <img class="logo" src="../assets/LensAdvisors_cropped.svg" alt @click="$emit('click')" />
</template>

<script>
export default {
    name: 'LogoComponent'
}
</script>

<style lang="scss" scoped>
    img {
		position: absolute;
		top: 20px;
		left: 20px;
		cursor: pointer;
	}
</style>